import { defineKey as T } from 'ha/i18n';

export const ACTION_PREFIX = 'EDIT_LISTING';
export const STATE_NAME = 'editListing';

export const YOUTUBE_INPUT_NAME = 'youtubeUrl';
export const YOUTUBE_WATCH_URL = 'https://www.youtube.com/watch?v=';
export const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/';

export const Actions = {
  INITIALIZE: `${ACTION_PREFIX}/INITIALIZE`,
  LOAD_LISTING_START: `${ACTION_PREFIX}/LOAD_LISTING_START`,
  LOAD_LISTING_DONE: `${ACTION_PREFIX}/LOAD_LISTING_DONE`,
  LOAD_LISTING_FAIL: `${ACTION_PREFIX}/LOAD_LISTING_FAIL`,
  LOAD_LISTING_RESET_STATE: `${ACTION_PREFIX}/LOAD_LISTING_RESET_STATE`,

  UPDATE_LISTING_FAIL: `${ACTION_PREFIX}/UPDATE_LISTING_FAIL`,
};

export const Messages = {
  LISTING_DUPLICATION_ERROR: T(`We could't duplicate your listing.`),
  LISTING_UPDATE_ERROR: T(
    'We could not update your listing. Please check the form and try again.',
  ),
};

export const VideoMessages = {
  errorTitle: T('Invalid URL, please provide a valid Youtube URL.'),
  loadingTitle: T('Video is loading!'),
};

export const WIZARD_FORM_TOTAL_STEPS = 6;
